import styled, { css } from 'styled-components';
import { MarketplaceStyled } from '../../../features/marketplace/assets/marketplaceStyle';
import { Modal } from 'react-bootstrap';

const modalSize = {
  xl: '1140px',
  md: '676px',
  xmd: '490px',
  sm: '320px',
};

export const Header = styled(MarketplaceStyled.FilterTitle)`
  display: flex;
  justify-content: space-between;
  align-items: start;
  h4 {
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 0;
    line-height: 22px;
  }
  svg {
    path {
      stroke: ${({ theme }) => theme.primaryDark};
    }
  }
`;

export const Title = styled.h5`
  font-size: 24px;
  color: ${({ theme }) => theme.secondaryLight};
  font-weight: 500;
`;

export const BootStrapModal = styled(Modal)`
  .modal-dialog {
    max-width: ${({ size }) => modalSize[size] ?? '100%'};
    .modal-content {
      border: 0;
      overflow-y: hidden;
      ${({ fullscreen }) =>
        fullscreen !== true &&
        css`
          .modal-body {
            max-height: calc(100vh - 60px);
            overflow-y: auto;
          }
        `}
    }
  }
`;

export const StyledModal = {
  Header,
  Title,
  BootStrapModal,
};
